export default __webpack_public_path__ + "static/blueHeroLeft-0a901127b6e7ae724130469d3a611423.png";